import React from "react";
import { ControlledBoard, KanbanBoard } from "@caldwell619/react-kanban";
import "@caldwell619/react-kanban/dist/styles.css";
import { ActionsKanbanCard } from "../../../Actions/ActionKanbanView/ActionsKanbanCard";
import "./_kanban.scss";
import { IF } from "../../../../../../components/hoc/If";

export interface CardProps {
  id: number;
  title: string;
  description: string;
  startDate?: Date;
  endDate?: Date;
  owner?: string;
  progressStatus?: number;
  ragStatus?: number;
  refNo?: string;
  type?: string;
  assignee?: string;
  projectStakeholderOwners?: string;
  labels?: string[];
  noteCount?: number;
  impacts?: any;
}

interface KanbanProps {
  board: KanbanBoard<CardProps>;
  onCardDragEnd: (
    card: CardProps,
    source: { fromColumnId: number; fromPosition: number },
    destination: { toColumnId: number; toPosition: number }
  ) => void;
  onCardDelete: (cardId: number[], columnId: number, cardTitle: string) => void;
}

export const KanbanView: React.FC<KanbanProps> = ({ board, onCardDragEnd, onCardDelete }) => {
  return (
    <ControlledBoard
      children={board}
      renderCard={card => <ActionsKanbanCard card={card} onDelete={onCardDelete} />}
      renderColumnHeader={column => (
        <div className="react-kanban-column-header">
          <span>{column.title}</span>
          <IF condition={column.cards.length > 0}>
            <span>{column.cards.length}</span>
          </IF>
        </div>
      )}
      onCardDragEnd={onCardDragEnd}
      allowRemoveCard={false}
      allowRemoveColumn={false}
      allowRenameColumn={false}
      allowAddCard={false}
      disableColumnDrag={true}
    />
  );
};
